import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
  timeout: 20000,
});

export const createBooking = (payload) => api.post('/bookings', payload).then((r) => r.data);
export const createContact = (payload) => api.post('/contacts', payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post('/newsletter', { email }).then((r) => r.data);
export const getStats = () => api.get('/stats').then((r) => r.data);

export const readableError = (err) => {
  if (err?.response?.data?.detail) {
    const d = err.response.data.detail;
    if (typeof d === 'string') return d;
    if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  }
  return err?.message || 'Something went wrong. Please try again.';
};
